"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VISA = exports.BANK_STATEMENT = exports.BIRTH_CERTIFICATE = exports.NATIONAL_INSURANCE_CARD = exports.WORK_PERMIT = exports.RESIDENCE_PERMIT = exports.VOTER_ID = exports.TAX_ID = exports.DRIVING_LICENCE = exports.NATIONAL_IDENTITY_CARD = exports.PASSPORT = void 0;
// Onfido document types
exports.PASSPORT = 'passport';
exports.NATIONAL_IDENTITY_CARD = 'national_identity_card';
exports.DRIVING_LICENCE = 'driving_licence';
exports.TAX_ID = 'tax_id';
exports.VOTER_ID = 'voter_id';
exports.RESIDENCE_PERMIT = 'residence_permit';
exports.WORK_PERMIT = 'work_permit';
exports.NATIONAL_INSURANCE_CARD = 'national_insurance_card';
exports.BIRTH_CERTIFICATE = 'birth_certificate';
exports.BANK_STATEMENT = 'bank_statement';
exports.VISA = 'visa';
